import { useSearchParams } from 'react-router-dom'
import { Button } from 'components/common'
import { CloseIcon } from 'components/icons'

type Props = {
  /** Query-param key under which the page's filters are persisted */
  filterKey: string
}

/**
 * Renders a "Clear Filters" button in a log page header. It is only visible
 * while filters are applied (i.e. the filter key is present in the URL) and
 * removes them on click, resetting the listing back to its unfiltered state.
 */
const ClearFiltersButton = ({ filterKey }: Props) => {
  const [searchParams, setSearchParams] = useSearchParams()

  const hasFilters = Boolean(searchParams.get(filterKey))

  if (!hasFilters) {
    return null
  }

  const handleClearFilters = () => {
    // Remove the filter key and reset pagination in a single update so the
    // change is applied atomically (sequential setSearchParams calls would
    // overwrite each other and re-add the key).
    const nextParams = new URLSearchParams(searchParams)
    nextParams.delete(filterKey)
    nextParams.set('page', '1')
    setSearchParams(nextParams)
  }

  return (
    <Button
      type="button"
      buttonText="Clear Filters"
      variant="custom"
      icon={<CloseIcon />}
      iconClassName="!h-4 !w-4 text-error"
      className="rounded-lg px-3.5 py-2 text-sm font-semibold text-error hover:bg-gray-200"
      onClick={handleClearFilters}
    />
  )
}

export default ClearFiltersButton
